// Shared Swiper config
export const SWIPER_CONFIG = {
    grabCursor: true,
    preloadImages: false,
    keyboard: {
        enabled: true,
    },
};
